<template>
  <div>
    <div class="wrapper">
      <div class="sectionImageWrapper" ref="sectionImageWrapper" v-if="windowWidth >= 1000">
        <img class="sectionImage imageAnimation" :src="content.tweenImage" v-show="tweenedImage">
      </div>
      <div class="sectionImageWrapper" ref="sectionImageWrapper" v-if="windowWidth < 1000">
        <img class="sectionImageMobile imageAnimationOpacity" :src="content.tweenImageMobile" v-show="tweenedImage">
      </div>

      <div class="sectionInfoWrapper boxShadow">
        <div class="cornerTop" />
        <div class="cornerBottom" />
        <div class="lineWrapper">
          <h1 class="sectionHeadline fromBottomDirect transition"
              :class="tweenedHeadline ? 'presentHead' : 'unpresentHead'"
              :ref="content.headline">{{ content.headline }}</h1>
          <div class="textInfo fromBottomDirect transition">
            <h3 class="subHeadline"
                :ref="content.subheadline"
                :class="tweenedHeadline ? 'presentHead' : 'unpresentHead'">{{ content.subheadline }}</h3>
            <br/>
            <p class="fromBottomDirect text transition"
                style="text-transform: none;"
               :ref="content.text" v-html="content.text"
               :class="tweenedText ? 'presentHead' : 'unpresentHead'"></p>
          </div>

          <div v-if="content.withSlot">
            <div class="sectionInfo transition" ref="slotInfo">
                <slot />
            </div>
          </div>
          <!--
          <div class="imagesInfo">
            <vue-gallery-slideshow :images="content.images" :index="imageIndexGallery" @close="index = null; releaseTabbar()"></vue-gallery-slideshow>
            <img
              class="thumb"
              v-for="(image, imageIndex) in content.images"
              :src="image"
              :key="imageIndex"
              @click="imageIndexGallery = imageIndex; hideTabbar()"
              :style="imageIndex & 1 ? {transform: 'rotateZ(15deg)'} : {transform: 'rotateZ(-8deg)'}"
            >
          </div>
          -->
        </div>
        <!--
          <h1 class="sectionHeadline"
            ref="headline"
            :class="tweenedHeadline ? 'presentHead' : 'unpresentHead'">{{ content.headline }}</h1>
        <div class="sectionInfo" ref="sectionInfo" v-bind:style="tweened ? {opacity: 1} : {opacity: 0}">
          <div class="imagesInfo">
            <vue-gallery-slideshow :images="content.images" :index="imageIndexGallery" @close="index = null; releaseTabbar()"></vue-gallery-slideshow>
            <img
              class="thumb"
              v-for="(image, imageIndex) in content.images"
              :src="image"
              :key="imageIndex"
              @click="imageIndexGallery = imageIndex; hideTabbar()"
              :style="imageIndex & 1 ? {transform: 'rotateZ(15deg)'} : {transform: 'rotateZ(-8deg)'}"
            >
          </div>
          <div class="textInfo fromBottomDirect">
            <h3>{{ content.subheadline }}</h3>
            <br/>
          </div>
          <p :ref="content.headline + 'text'" v-html="content.text"></p>
        </div>
        <div v-if="content.withSlot">
          <div class="sectionInfo" ref="slotInfo"
              v-bind:style="tweenedSlot ? {opacity: 1} : {opacity: 0}">
              <slot />
          </div>
        </div>
        -->
      </div>
    </div>
  </div>
</template>

<script>
import { throttle, debounce } from 'throttle-debounce';

export default {
  name: 'baseSection',
  data: () => {
    return {
      tweenedSubheadline: false,
      tweenedText: false,
      tweenedSlot: false,
      tweenedImage: false,
      tweenedHeadline: false
    }
  },
  props: ['content', 'windowWidth'],
  mounted(){
    window.addEventListener('scroll', throttle(300, () => {
      this.handleScroll()
      })
    );
  },
  methods:{
    handleScroll(){
      if(this.$refs[this.content.headline] != undefined){
        if(this.isScrolledIntoView(this.$refs[this.content.headline])){
          this.tweenedHeadline = true
        } else if(!this.isScrolledIntoView(this.$refs[this.content.headline])){
          this.tweenedHeadline = false
        }
      }

      if(this.$refs[this.content.subHeadline] != undefined){
        if(this.isScrolledIntoView(this.$refs[this.content.subHeadline])){
          this.tweenedSubheadline = true
        } else if(!this.isScrolledIntoView(this.$refs[this.content.subHeadline])){
          this.tweenedSubheadline = false
        }
      }

      if(this.$refs[this.content.text] != undefined){
        if(this.isCompletelyScrolledIntoView(this.$refs[this.content.text])){
          this.tweenedText = true
        } else if(!this.isCompletelyScrolledIntoView(this.$refs[this.content.text])){
          this.tweenedText = false
        }
      }

      if(this.$refs.slotInfo != undefined){
        if(this.content.withSlot){
          if(this.isCompletelyScrolledIntoView(this.$refs.slotInfo)){
            this.tweenedSlot = true
          } else if(!this.isCompletelyScrolledIntoView(this.$refs.slotInfo)){
            this.tweenedSlot = false
          }
        }
      }

      if(this.$refs.sectionImageWrapper != undefined){
        if(this.isCompletelyScrolledIntoView(this.$refs.sectionImageWrapper)){
          this.tweenedImage = true
        } else if(!this.isCompletelyScrolledIntoView(this.$refs.sectionImageWrapper)){
          this.tweenedImage = false
        }
      }
    },
    isScrolledIntoView(el) {
      if (el != undefined){
        let rect = el.getBoundingClientRect();
        let elemTop = rect.top;
        let elemBottom = rect.bottom;
        let isVisible = (elemBottom <= (window.innerHeight - 200));
        //let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
        return isVisible;
      }
    },
    isCompletelyScrolledIntoView(el) {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;
      //let isVisible = (elemBottom <= window.innerHeight);
      let isVisible = elemTop < window.innerHeight && elemBottom >= 0;

      return isVisible;
    },
    releaseTabbar(){
      this.$emit('releaseTabbar');
    },
    hideTabbar(){
      this.$emit('hideTabbar');
    }
  },
  beforeDestroy(){
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="scss">
div.wrapper{
  position: relative;
  display: block;
  width:100%;
  color: #e0ffff;
}
div.lineWrapper{
  max-width: 1000px;
  width: 90%;
  margin: auto;
  display: block;
  position: relative;
}
h1.sectionHeadline{
  position: relative;
  margin: auto auto 3%;
  text-align: center;
  font-size: calc(3vw + 3em);
  text-decoration: underline overline #7F0000;
}
div.sectionInfo{
  display: block;
  width: 90%;
  max-width: 1000px;
  margin: auto;
  position: relative;
  z-index: 5;
  transition: all 1s;
}
@media only screen and (max-width: 600px){
  div.sectionInfo{
    display: block;
  }
}
/*
div.sectionInfoWrapper:before{
  content: '';
  position: absolute;
  top: 0;
  left: 0%;
  width: 100%;
  height: 300px;
  background-image: linear-gradient(to right bottom, #5e1224, #5d1f2c, #5b2933, #58323a, #553b40, #574049, #574552, #574b59, #515269, #3e5b75, #1f6579, #006e70);
  transform-origin: right;
  transform: skewY(5deg);
  z-index: 1;
  border-bottom: 1px solid #504648;
}
*/
div.sectionInfoWrapper{
  display: block;
  position: relative;
  z-index: 5;
  //background-image: linear-gradient(to top,#000, #553b40, #4d1f2c, #58323a, #553b40, #000);
  //background-image: url("../assets/muster.png");
  background: black;
  //box-shadow: 0px 0px 100px rgba(255, 255, 255, 0.8) inset;
  padding-top: 10%;
  padding-bottom: 10%;
}
div.textInfo{
  width: 90%;
  margin: 10% auto;
  text-align: center;
  transition: transform 0.6s ease, opacity 0.3s ease;
  color: white;
}
.arrowRight {

}
div.imagesInfo{
  width: 90%;
  margin: auto;
  display: block;
  transition: transform 1.2s ease, opacity 0.6s ease;
}
img.thumb{
  position: relative;
  width: 80%;
}
div.sectionImageWrapper{
  position: relative;
  display: block;
  width:100%;
  height:200vw;
}
@media only screen and(min-width: 800px){
  div.sectionImageWrapper{
    position: relative;
    display: block;
    width:100%;
    height:100vh;
  }
}

/*
div.sectionImageWrapper:after{
  content: '';
  position: absolute;
  top: 0%;
  left: 0%;
  width: 100%;
  height: 300px;
  background-image: linear-gradient(to right top, #5e1224, #5d1f2c, #5b2933, #58323a, #553b40, #574049, #574552, #574b59, #515269, #3e5b75, #1f6579, #006e70);
  transform-origin: right;
  transform: skewY(8deg);
  z-index: 1;
}
*/
img.sectionImage{
  position: fixed;
  top:0;
  width: 100%;
  height:auto;
  z-index: 0;
  transition: opacity 0.6s;
}
img.sectionImageMobile{
  position: fixed;
  top:0;
  width: auto;
  height:100%;
  z-index: 0;
  transition: opacity 0.6s;
}
.presentHead{
  animation-name: getBig;
  animation-duration: 0.7s;
  animation-delay:0s;
  animation-fill-mode:forwards;
}
.unpresentHead{
  animation-name: getSmall;
  animation-duration: 0.7s;
  animation-delay:0s;
  animation-fill-mode:forwards;
}
.transition{
  display: block;
  transition:all 0.8s ease-in;
}
@keyframes getBig {
  0%{
    opacity: 0;
    transform: translateY(200px);
  }
  100%{
    transform: translateY(0px);
    opacity: 1;
  }
}
@keyframes getSmall {
  0%{
    transform: translateY(0px);
    opacity: 1;
  }
  100%{
    transform: translateY(200px);
    opacity: 0;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/baseSection.vue